export const TAB_CONTAINER_SELECTOR = '.tabbed-sections > div > ul'
export const TAB_ITEMS_SELECTOR = '.tabbed-sections > div > ul li'
